import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import store from './store'
import VueElementLoading from 'vue-element-loading'
import SnackBar from './components/Common/snackBar'
import ServerError from './components/Common/500'
import ImageLoader from './components/Common/imageLoader'
import PageLoader from './components/Common/pageLoader'


import ImageMagnifier from 'vue-image-magnifier'
Vue.use(ImageMagnifier)

import OwlCarousel from 'vue-owl-carousel'

// import VueSocialSharing from 'vue-social-sharing'


import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.component('OwlCarousel', OwlCarousel)
Vue.component('ServerError', ServerError)
Vue.component('SnackBar', SnackBar)
Vue.component('ImageLoader', ImageLoader)
Vue.component('PageLoader', PageLoader)
Vue.component('VueElementLoading', VueElementLoading)

Vue.config.productionTip = false
window.axios = require('axios')
axios.defaults.baseURL = 'http://65.0.180.156';
Vue.prototype.baseURL = "http://65.0.180.156"
// Vue.prototype.mediaURLOld = "https://65.0.180.156/u/"
Vue.prototype.mediaURL = "http://65.0.180.156/u/"

Vue.mixin({
  data() {
    return {
      webpSupported: true,
    };
  },

  created() {
    (async () => {
      // If browser doesn't have createImageBitmap, we can't use webp.
      if (!self.createImageBitmap) {
        this.webpSupported = false;
        return;
      }
      // Base64 representation of a white point image
      const webpData =
        "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";
      // Retrieve the Image in Blob Format
      const blob = await fetch(webpData).then((r) => r.blob());
      // If the createImageBitmap method succeeds, return true, otherwise false
      this.webpSupported = await createImageBitmap(blob).then(
        () => true,
        () => false
      );
      if (this.webpSupported) {
        Vue.prototype.mediaURL = "http://65.0.180.156/u/";
      } else {
        Vue.prototype.mediaURL = "http://65.0.180.156/u/";

      }
    })();
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
